import css from 'styled-jsx/css';

const styles = css.global`#cdc-informacoes {
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.30) 0%, rgba(0, 0, 0, 0.30) 100%), #222;
    overflow: hidden;
    padding: 40px 0 64px;
    margin-top: 56px;
}

#cdc-informacoes .ctn-home-24 {
    display: flex;
    flex-direction: column;
    gap: 40px;
}

#cdc-informacoes .informacoes-contain-1 {
    display: flex;
    flex-direction: column;
    gap: 32px;
}

#cdc-informacoes .informacoes-contain-1-textos  {
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 0 16px;
}

#cdc-informacoes .informacoes-contain-1-titulo {
    color: #FFF;
    font-family: "SantanderHeadline";
    font-size: 32px;
    font-style: normal;
    font-weight: 400;
    line-height: 48px;
}

#cdc-informacoes .informacoes-contain-1-texto {
    color: #FFF;
    font-family: "SantanderText";
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 28px;
}

#cdc-informacoes .informacoes-contain-1-docs,
#cdc-informacoes .informacoes-contain-1-docs div {
    display: flex;
    flex-direction: column;
    gap: 24px;
}

#cdc-informacoes .informacoes-contain-1-doc {
    display: flex;
    gap: 16px;
    align-items: center;
    width: 351px;
}

#cdc-informacoes .informacoes-contain-1-doc-titulo {
    color: #FFF;
    font-family: "SantanderText";
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 100%; /* 18px */
    text-decoration-line: underline;
    text-decoration-style: solid;
    text-decoration-skip-ink: none;
    text-decoration-thickness: auto;
    text-underline-offset: auto;
}

#cdc-informacoes .informacoes-contain-2 {
    position: relative;
    padding: 253px 8px 54px 8px;
    border-radius: 4px;
    border: 1px solid #C00;
}

#cdc-informacoes .informacoes-contain-2 .informacoes-contain-2-docs {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: flex-start;
    gap: 32px;
}
#cdc-informacoes .informacoes-contain-2 .img-informacoes {
    position: absolute;
    height: 255px;
    top: -20px;
    left: 50%;
    transform: translate(-50%, 0);
}

#cdc-informacoes .informacoes-contain-2-titulo {
    color: #FFF;
    font-family: "SantanderHeadline";
    font-size: 34px;
    font-style: normal;
    font-weight: 400;
    line-height: 40px;
    margin: 0;
}

#cdc-informacoes .informacoes-contain-2-doc {
    display: flex;
    gap: 16px;
    align-items: center;
}

#cdc-informacoes .informacoes-contain-2-doc-titulo {
    color: #FFF;
    font-family: "SantanderText";
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 100%;
}

#cdc-informacoes .informacoes-contain-2-doc-vigencia {
    color: #999;
    font-family: "SantanderMicroText";
    font-size: 14px;
    font-style: normal;
    font-weight: 300;
    line-height: 22px; 
}

#seguro-prestamista-cdc {
    padding-top: 8px;
}

#seguro-prestamista-cdc .seguro-prestamista-cdc-texto {
    color: #999;
    font-family: "SantanderMicroText";
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 22px;
}

@media (min-width: 992px) {
    #cdc-informacoes {
        padding: 40px 0 80px;
        margin-top: 64px;
    }

    #cdc-informacoes .ctn-home-24 {
        gap: 64px;
        max-width: 1279px;
    }

    #cdc-informacoes .ctn-home-24 .informacoes-contain-1 {
        max-width: 1208px;
        margin: auto;
    }

    #cdc-informacoes .informacoes-contain-1-textos  {
        gap: 24px;
        padding: 0 0 36px 0;
    }

    #cdc-informacoes .informacoes-contain-1-titulo {
        font-size: 40px;
        line-height: 60px;
    }
    
    #cdc-informacoes .informacoes-contain-1-texto {
        font-size: 24px;
        line-height: 36px;
    }

    #cdc-informacoes .informacoes-contain-1-docs {
        flex-direction: row;
        gap: 88px;
    }

    #cdc-informacoes .informacoes-contain-2 {
        display: flex;
        padding: 0;
        gap: 108px;
        align-items: flex-start;
        height: 268px;
    }
    
    #cdc-informacoes .informacoes-contain-2 .informacoes-contain-2-docs {
        margin-top: 33px;
        gap: 27px;
    }
    #cdc-informacoes .informacoes-contain-2 .img-informacoes {
        position: initial;
        transform: none;
        margin-left: -150px;
        width: auto;
        height: 317px;
        margin-top: -40px;
    }

    #seguro-prestamista-cdc .ctn-home-24 {
        max-width: 1200px;
    }
}`;

export default styles;